import Vue from 'vue';
import authStore from '@/store/auth';
import logger from '../logger';

/**
 * 针对控件做数据埋点
 */
Vue.directive('control-logger', {
  bind(el, binding) {
    const { modifiers = {} } = binding;
    let { value } = binding;
    if (Object.prototype.toString.apply(value) !== '[object Object]') {
      value = {};
    }
    // 获取页面字段对应的显示名称
    let pageTitle = document.title;
    const { route = {} } = value;
    if (route.meta && route.meta.title) {
      pageTitle = route.meta.title;
    }
    delete value.route;
    if (modifiers.click) {
      el.addEventListener('click', (event) => {
        Vue.prototype.$vSensors.sensors.quick('trackHeatMap', event.target);
        const loggerInfo = authStore.state.loggerInfoFromSwjApp;
        logger.click({
          actionType: 'click_APP_native',
          eventLabel: JSON.stringify({
            pageTitle,
            ...value,
          }),
          ...loggerInfo,
        });
      }, true);
    }
  },
});
